export { default as RoleSummary } from './RoleSummary';
export type { RoleSummaryProps } from './RoleSummary';
export { getRoleCapabilities, countUndescribed } from './capabilities';
export type { RoleCapability } from './capabilities';
